/* eslint-disable max-len */
import React from 'react'

export default function AdorSupport({type, Details}) {
    const SmallRoles = ['Business Head','Regional Business Manager','Area Sales Manager']
    const capitalizeFirstChracter = (string) => {
        let finalString = '';
        string.split('_').forEach((final) => {
            finalString += final.charAt(0).toUpperCase();
        });
        return finalString;
    };

    return (
        <div className={`tab-pane fade  pt-[18px] ${type==='Ador Support' ? 'show active':''}` } style={{minHeight:"50vh"}}
            id="pills-adorsupport" role="tabpanel" aria-labelledby="pills-adorsupport-tab">
            <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 lg:gap-7 md:gap-5 gap-4">
                
                {Details?.SUPPORTS.map((Role)=>(
                    <div className="bg-[#FFFFFF] rounded-lg shadow-s7" key={Role.EMPLOYEE_CODE}>
                        <div className="border-b-4 rounded-lg rounded-tl-none rounded-tr-none border-[#ED1C24] px-[18px] pt-4">
                            <p className="text-lg font-bold text-[#090406]">{Role.FIRST_NAME} {Role.LAST_NAME}</p>
                            <p className="text-xs3 font-normal text-[#808285] capitalize"> 
                                {['area_sales_engineer'].includes(Role?.ROLES) ? capitalizeFirstChracter(Role?.ROLES) : capitalizeFirstChracter(Role?.ROLES).replace('S', 'B')} ({Role.PRODUCT_CATEGORIES.join(' , ')})</p>
                            <div className="flex -mx-1 pt-5">
                                <div className="px-1 w-1/2">
                                    <p className="text-xs font-semibold text-[#808285]">Mobile Number</p>
                                    <p className="text-base font-normal text-[#090406]"> {Role?.PHONE_NUMBER} </p>
                                </div>
                            </div>
                            <div className="px-1 w-1/2 pt-3.5 pb-[22px]">
                                <p className="text-xs font-semibold text-[#808285]">Email Address</p>
                                <a href={`mailto:${Role.EMAIL}`}><p className="text-base underline font-normal text-[#090406] hover:text-[#ED1C24]">{Role.EMAIL}</p></a>
                            </div>
                        </div>
                    </div>
                ))}
                
                
            </div>
            <div className="mt-5 grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 lg:gap-7 md:gap-5 gap-4">
                {Details?.SUPPORTS.filter((val)=>SmallRoles.includes(val.ROLES)).map((Role)=>(
                    <div className="bg-[#FFFFFF] rounded-lg shadow-s7" key={Role.EMAIL}>

                        <div 
                            className="border-b-4 rounded-lg rounded-tl-none rounded-tr-none border-[#ED1C24] px-[18px] pt-4"
                        >
                            <p className="sm:text-lg text-base font-bold text-[#090406]">{Role.FIRST_NAME} {Role.LAST_NAME}</p>
                            <p className="text-xs3 font-normal text-[#808285] pb-[18px]">{Role.ROLES}</p>
                        </div>
                    </div>

                ))}
            </div>
        </div> 
    )
}